import React from "react"

import Bowser from "bowser"
import { Main } from "../styles/Container"

const browser = Bowser.getParser(
  typeof window !== "undefined" ? window.navigator.userAgent : "NoBrowser"
)

export default function BrowserNotSupported() {
  return (
    <Main>
      <h2 style={{ margin: "3rem" }}>Vi støtter ikke nettleseren din</h2>

      <br />
      {typeof window !== undefined &&
      browser.getBrowser().name === "Internet Explorer" ? (
        <p>
          Denne appen støtter ingen versjoner av Internet Explorer. Se{" "}
          <a href="https://browsehappy.com/?locale=nb_NO">Surf Lykkelig</a> for
          forslag til moderne nettlesere.
        </p>
      ) : (
        <p>
          Vennligst oppgrader til en nyere versjon eller{" "}
          <a href="https://browsehappy.com/?locale=nb_NO">velg en annen</a>. Det
          forbedrer også sikkerheten.
        </p>
      )}
    </Main>
  )
}
